export enum RECOVERY_CODE_STEPS {
    SendOtpCode,
    SaveRecoveryCodes
}
